module.exports = __webpack_public_path__ + "img/TZ.3027ea3f.svg";